import React, { useState, useEffect } from 'react';
import {
  Row,
  Col,
  Form,
  Card,
  Space,
  Input,
  DatePicker,
  Select,
  message,
  Image,
  Alert
} from 'antd';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { EditOutlined } from '@ant-design/icons';
import CustomButton from '@/common/CustomButton';
import FormItem from '@/common/FormItem';
import Layout from '@/common/Layout';
import styles from '@/common/Layout/index.module.less';
import 'react-quill/dist/quill.snow.css';
import { getLoggedInUser } from 'utilities/helpers';
import apiClient from 'utilities/apiClient';
import { history } from 'app/history';
import truck from '../images/truck-delivery-done.gif';
import { getAllBatches, createTestForm } from '../../redux/slice';
import { TEST_TO_BE_PERFORMED_OPTIONS } from '@/common/Utils/testToBePerformed';
// import { PlusOutlined } from '@ant-design/icons';

const TestRequestForm = ({ loading }) => {
  const { batchdetails } = useSelector((state) => state.qaapproval);
  console.log(batchdetails);
  const searchParam = useLocation().search;
  const searchParams = new URLSearchParams(searchParam);
  const { user } = getLoggedInUser();

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [isEdit, setIsEdit] = useState(false);

  const [samplings, setSamplings] = useState();
  const [truckShow, setTruckShow] = useState(false);
  const [damagedCount, setDamagedCount] = useState('');
  /* Set when the backend refuses a Re-Generate because a test request is
     already open on this batch. Only one may run at a time. */
  const [blockedBy, setBlockedBy] = useState(null);
  /* Only a QC Level 3 user records a result on this form. Below that the whole
     "To be Filled by Quality Control" section is read-only - the fields are still
     shown, because the values matter to everyone, but they cannot be typed. */
  const qcSectionLocked = user?.level !== 3;
  const [reprinting, setReprinting] = useState(false);

  /* Re-print the CURRENT state of this test request.
     Not the blob stored at creation: that one was rendered before QC entered the
     AR at /qc-approval, so it shows NA where the AR should be. create-trf-pdf
     re-reads the request row and renders it fresh.
     Routed through apiClient.getBlob because /trf sits behind verify_auth
     (routes/index.js:117) — a plain window.open carries no token and gets a 403,
     and getBlob sends both the auth and X-Session-Token headers. */
  const handleReprint = () => {
    const trfId = samplings?.test_request_form?.id;
    if (!trfId) return;
    setReprinting(true);
    apiClient
      .getBlob(
        `${process.env.REACT_APP_API_URL}/trf/create-trf-pdf`,
        {
          batch_details_id: searchParams.get('id'),
          test_request_form_id: trfId
        },
        true
      )
      .then((blob) => {
        setReprinting(false);
        if (!(blob instanceof Blob)) {
          message.error('Could not re-print the test request form.');
          return;
        }
        const url = window.URL.createObjectURL(
          new Blob([blob], { type: 'application/pdf' })
        );
        window.open(url, '_blank');
        /* Released on the next tick: revoking immediately can beat the new tab
           to the URL. */
        setTimeout(() => window.URL.revokeObjectURL(url), 60000);
      })
      .catch(() => {
        setReprinting(false);
        message.error('Could not re-print the test request form.');
      });
  };
  /* Drives the retest-only fields. Seeded from the batch on load so a form
     reopened on a retest cycle still offers them. */
  const [selectedTest, setSelectedTest] = useState(undefined);
  const [retestEdit, setRetestEdit] = useState(false);

  const dateFormat = 'DD-MM-YYYY';

  /* `moment(null).format('DD MMM YYYY')` returns the string "Invalid date", and a
     non-empty string is truthy — so the `|| 'NA'` fallbacks these fields were
     written with could never fire, and an unset date rendered as "Invalid date".
     Guard on validity instead of on the formatted output. */
  const formatDate = (value) =>
    value && moment(value).isValid()
      ? moment(value).format('DD MMM YYYY')
      : 'NA';

  useEffect(() => {
    handleGetAllBatchList();
  }, []);
  const handleGetAllBatchList = () => {
    let payload = {
      id: searchParams.get('id'),
      type: searchParams.get('type')
    };
    dispatch(getAllBatches(payload)).then((response) => {
      if (response?.payload?.success) {
        setSamplings(response?.payload?.data);
        let damaged_conatiners = response?.payload?.data?.containers?.filter(
          (data) => data?.is_damaged
        );
        setDamagedCount(damaged_conatiners.length);
        form.setFieldsValue({
          ar_no: response?.payload?.data?.test_request_form?.ar_no
        });
        form.setFieldsValue({
          sampled_date: response?.payload?.data?.test_request_form?.sampled_date
            ? moment(
                response?.payload?.data?.test_request_form?.sampled_date,
                'YYYY-MM-DD'
              )
            : ''
        });
        form.setFieldsValue({
          sample_quantity:
            response?.payload?.data?.test_request_form?.sample_quantity
        });
        form.setFieldsValue({
          test_performed:
            response?.payload?.data?.test_request_form?.test_performed
        });
        form.setFieldsValue({
          analytical_status:
            response?.payload?.data?.test_request_form?.analytical_status
        });
        form.setFieldsValue({
          remarks: response?.payload?.data?.test_request_form?.remarks
        });

        form.setFieldsValue({
          trf_serial_no: response?.payload?.data?.trf_serial_no
        });
        form.setFieldsValue({
          test_to_be_performed: response?.payload?.data?.test_to_be_performed
        });
        setSelectedTest(response?.payload?.data?.test_to_be_performed);
        form.setFieldsValue({
          retest_container_count:
            response?.payload?.data?.test_request_form?.retest_container_count
        });
        response?.payload?.data?.test_request_form?.id
          ? setIsEdit(false)
          : setIsEdit(true);
      }
    });
  };
  console.log(isEdit);
  const onFinish = (Values) => {
    setTruckShow(true);
    /* Clear any previous block before retrying. Without this the banner would
       stay on screen after a QC Level 3 user closes the offending request and the
       warehouse successfully raises the next cycle. */
    setBlockedBy(null);
    Values['batch_details_id'] = searchParams.get('id');
    // Pass batch qc_status so the thunk can route correctly: when the batch is
    // still in Quarantine, the TRF must be "initiated" (status-flip side effects
    // fire) even if a TRF row was pre-populated upstream (e.g. code-to-code child).
    Values['batch_qc_status'] = samplings?.qc_status;
    samplings?.test_request_form?.id
      ? (Values['trf_id'] = samplings?.test_request_form?.id)
      : '';
    // Lets the thunk tell a request that was actually raised from a row merely
    // pre-populated by code-to-code transfer (lifecycle still NULL), which is
    // the only case that still needs create-trf while the batch is Quarantine.
    Values['trf_request_status'] = samplings?.test_request_form?.request_status;
    samplings?.test_request_form?.id &&
    (user?.role == 'user' || user?.role == 'qa_super_user')
      ? (Values['type'] = 'regenerate')
      : '';
    console.log(Values);
    dispatch(createTestForm(Values)).then((response) => {
      if (response?.payload?.success) {
        setTruckShow(false);
        /* Open the generated form for printing.
           Gated on the RESPONSE, not on a pre-existing request row. The old
           condition meant the very submit that raises the request and generates
           the PDF never opened it — only a later re-submit did, by which time a
           row existed.
           create-trf and update-trf return the blob URL in `data`; regenerate_trf
           returns an object describing the new cycle, so only a string is a PDF
           (calling .split on that object threw for qa_super_user). */
        const trfPdf =
          typeof response?.payload?.data === 'string'
            ? response?.payload?.data
            : null;
        /* Superseded condition, kept for reference:
             samplings?.test_request_form?.id && user?.role !== 'user' */
        trfPdf && user?.role !== 'user'
          ? window.open(
              `${process.env.REACT_APP_STORAGE_URL}${trfPdf.split('/').pop()}`,
              '_blank'
            )
          : // window.open(response?.payload?.data, '_blank')
            '';
        message.success(response?.payload?.message);
        user?.role == 'user' || user?.role == 'qa_super_user'
          ? history.push(`list`)
          : history.push(`/batches-list?type=test_requests`);
      } else {
        setTruckShow(false);
        /* apiClient returns the parsed body whatever the status, so the 409 the
           backend sends when a cycle is already open arrives here rather than as
           a rejection. It carries which request is blocking and who raised it. */
        if (response?.payload?.data?.cycle_no) {
          setBlockedBy(response?.payload?.data);
        }
      }
    });
    console.log(Values);
  };

  return (
    <Layout sider={false}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        // onFinishFailed={onFinishFailed}
      >
        {blockedBy ? (
          <Alert
            type="warning"
            showIcon
            style={{ marginBottom: '12px' }}
            message="Cannot raise a new test request"
            description={
              <>
                <div>
                  Request #{blockedBy?.cycle_no} ·{' '}
                  {blockedBy?.test_requested || 'Test'} ·{' '}
                  {blockedBy?.request_status}
                  {blockedBy?.trf_serial
                    ? ` · Serial ${blockedBy?.trf_serial}`
                    : ''}
                </div>
                {blockedBy?.raised_by ? (
                  <div>
                    Raised
                    {blockedBy?.raised_at
                      ? ` ${moment(blockedBy?.raised_at).format('DD-MMM-YYYY')}`
                      : ''}{' '}
                    by {blockedBy?.raised_by}
                  </div>
                ) : null}
                <div>
                  A QC Level 3 user must close it before a new one can be
                  raised.
                </div>
              </>
            }
          />
        ) : null}
        <Card
          title="TEST REQUEST FORM"
          className={styles.CustomPanel}
          extra={
            /* A retest re-states what is being drawn from the batch, so it
               unlocks the two fields that differ from the original MRN. */
            selectedTest === 'Retest' &&
            (user?.role == 'user' || user?.role == 'qa_super_user') ? (
              <CustomButton
                type="primary"
                ghost
                size="small"
                onClick={() => setRetestEdit(!retestEdit)}
              >
                <EditOutlined /> {retestEdit ? 'Done' : 'Edit retest details'}
              </CustomButton>
            ) : null
          }
        >
          <>
            <Card className={styles.SubPanel3}>
              <Row gutter={24}>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="Test to be Performed"
                    name="test_to_be_performed"
                    rules={[
                      {
                        required: false,
                        message: 'Enter No.of Containers'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    {user?.role == 'user' || user?.role == 'qa_super_user' ? (
                      <Select
                        placeholder="Select test perfomed"
                        onChange={(value) => {
                          setSelectedTest(value);
                          /* Switching away from Retest closes the retest edit, so
                             the extra fields cannot be left enabled under a test
                             that has no use for them. */
                          if (value !== 'Retest') setRetestEdit(false);
                        }}
                        // disabled={!isEdit}
                      >
                        {TEST_TO_BE_PERFORMED_OPTIONS.map((opt) => (
                          <option value={opt} key={opt}>
                            {opt}
                          </option>
                        ))}
                      </Select>
                    ) : (
                      <Input
                        value={samplings?.test_to_be_performed || 'NA'}
                        disabled
                      />
                    )}

                    {/* > */}
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="Date"
                    rules={[
                      {
                        required: false,
                        message: 'Select Date'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input
                      /* The date of the request being shown, not of the batch.
                         Bound to the batch's createdAt, this read 30-Sep for a
                         cycle raised days later — every cycle reported the same
                         date. Falls back to the batch only when no request exists
                         yet, i.e. the form is being raised for the first time. */
                      value={formatDate(
                        samplings?.test_request_form?.createdAt ||
                          samplings?.createdAt
                      )}
                      disabled
                    />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="Serial Number"
                    name="trf_serial_no"
                    rules={[
                      {
                        required: false,
                        message: 'Enter Serial Number'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input placeholder="Please Enter Serial Number" disabled />
                    {/* {user?.role == 'user' ? (
                      <Input placeholder="Please Enter Serial Number" />
                    ) : (
                      <Input value={samplings?.id} disabled />
                    )} */}
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="Material Code"
                    rules={[
                      {
                        required: false,
                        message: 'Enter Material Code'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input value={samplings?.material?.code} disabled />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="Name of the Material"
                    rules={[
                      {
                        required: false,
                        message: 'Enter Material Name'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input value={samplings?.material?.name} disabled />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="Vendor Batch/ LOT number"
                    rules={[
                      {
                        required: false,
                        message: 'Enter Vendor Batch/ LOT number'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input value={samplings?.mfg_batch_lot_no} disabled />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="Name of the Manufacturer"
                    rules={[
                      {
                        required: false,
                        message: 'Enter Name of the Manufacturer'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input
                      value={samplings?.supplier?.manufacturer_name}
                      disabled
                    />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="Name of the Supplier name"
                    rules={[
                      {
                        required: false,
                        message: 'Enter Name of the Supplier'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input value={samplings?.supplier?.name} disabled />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="InHouse Batch Number"
                    rules={[
                      {
                        required: false,
                        message: 'Enter InHouse Batch Number'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input value={samplings?.inhouse_batch_number} disabled />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="UOM"
                    rules={[
                      {
                        required: false,
                        message: 'Enter UOM'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input value={samplings?.material?.uom} disabled />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="MRN Number"
                    rules={[
                      {
                        required: false,
                        message: 'Enter MRN Number'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input value={samplings?.mrn_number || 'NA'} disabled />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="MRN Date"
                    rules={[
                      {
                        required: false,
                        message: 'Enter MRN Date'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input value={formatDate(samplings?.createdAt)} disabled />
                  </FormItem>
                </Col>

                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="Manufacturing Date"
                    rules={[
                      {
                        required: false,
                        message: 'Enter Manufacturing Date'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input value={formatDate(samplings?.mfg_date)} disabled />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="MFR Re-test Date"
                    rules={[
                      {
                        required: false,
                        message: 'Enter MFR Re-test Date'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input
                      value={formatDate(samplings?.mfg_retest_date)}
                      disabled
                    />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="MFG Expiry Date"
                    rules={[
                      {
                        required: false,
                        message: 'Enter MFG Expiry Date'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input
                      value={
                        samplings?.mfg_expiry_date
                          ? moment(samplings.mfg_expiry_date).format(
                              'DD MMM YYYY'
                            )
                          : 'NA'
                      }
                      disabled
                    />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="Assigned Inhouse Expiry Date"
                    rules={[
                      {
                        required: false,
                        message: 'Enter Assigned Inhouse Expiry Date'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input
                      value={
                        samplings?.in_house_expiry_date
                          ? moment(samplings.in_house_expiry_date).format(
                              'DD MMM YYYY'
                            )
                          : 'NA'
                      }
                      disabled
                    />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="Total Received Quantity as per MRN"
                    rules={[
                      {
                        required: false,
                        message: 'Enter Total Received Quantity'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input
                      value={samplings?.received_quantity || 'NA'}
                      disabled
                    />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="Closing Quantity"
                    rules={[
                      {
                        required: false,
                        message: 'Enter Closing Quantity'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input
                      value={
                        samplings?.stock_card_issuances[0]?.closing_balance ||
                        'NA'
                      }
                      disabled
                    />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="No.of Containers/Packs Received as per MRN"
                    rules={[
                      {
                        required: false,
                        message: 'Enter No.of Containers'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input
                      value={samplings?.containers_packs_received || 'NA'}
                      disabled
                    />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="No.of Containers for the Retest"
                    name="retest_container_count"
                    rules={[
                      {
                        required: false,
                        message: 'Enter No.of Containers for the retest'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    {/* Stored on the REQUEST, not the batch, so each retest cycle
                        keeps its own count. It is not the MRN figure beside it: the
                        batch may have been dispensed against since it was approved,
                        so the retest draws from what is actually left. */}
                    <Input
                      type="number"
                      min={0}
                      placeholder={
                        retestEdit
                          ? 'Enter No.of Containers for the retest'
                          : 'Select Retest to enter'
                      }
                      disabled={!retestEdit}
                    />
                  </FormItem>
                </Col>
                <Col xs={24} xl={12} span={12} md={24} sm={24}>
                  <FormItem
                    label="No.of Damaged Containers"
                    rules={[
                      {
                        required: false,
                        message: 'Enter No.of Containers'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    <Input value={damagedCount || 'NA'} disabled />
                  </FormItem>
                </Col>
                <Col xs={24} xl={24} span={24} md={24} sm={24}>
                  <FormItem
                    label="Remarks"
                    name="comments"
                    rules={[
                      {
                        required: false,
                        message: 'Enter Test to be Perfomed'
                      }
                    ]}
                    className={styles.customLable}
                  >
                    {user?.role == 'user' || user?.role == 'qa_super_user' ? (
                      <Input placeholder="Enter Remarks" />
                    ) : (
                      <Input
                        placeholder="Enter Remarks"
                        value={samplings?.remarks || ''}
                      />
                    )}
                  </FormItem>
                </Col>
              </Row>
            </Card>
            {
              // samplings?.test_request_form?.id &&
              user?.role !== 'user' ? (
                <Card
                  title="To be Filled by Quality Control"
                  extra={
                    samplings?.test_request_form?.id ? (
                      <CustomButton
                        onClick={() => setIsEdit(true)}
                        type="primary"
                        ghost
                        disabled={
                          /* Below Level 3 there is nothing to unlock. */
                          qcSectionLocked ||
                          (samplings?.test_request_form?.analytical_status ===
                          'Approved'
                            ? user?.level === 3
                              ? false
                              : true
                            : false)
                        }
                      >
                        <EditOutlined />
                      </CustomButton>
                    ) : (
                      ''
                    )
                  }
                >
                  <Row gutter={24}>
                    <Col xs={24} xl={12} span={12} md={24} sm={24}>
                      <FormItem
                        label="AR Number"
                        name="ar_no"
                        rules={[
                          {
                            required: false,
                            message: 'Enter AR number'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        {/* Never typed here. The AR number is assigned by QC at
                            the decision on /qc-approval and only mirrored onto
                            this form, so the field is read-only at every level
                            and simply shows the value once it exists. */}
                        <Input placeholder="Assigned at QC approval" disabled />
                      </FormItem>
                    </Col>
                    <Col xs={24} xl={12} span={12} md={24} sm={24}>
                      <FormItem
                        label="Sampled Date"
                        name="sampled_date"
                        rules={[
                          {
                            required: false,
                            message: 'Enter Sampled Date'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <DatePicker
                          format={dateFormat}
                          style={{ width: '100%' }}
                          disabled
                        />
                      </FormItem>
                    </Col>
                    <Col xs={24} xl={12} span={12} md={24} sm={24}>
                      <FormItem
                        label="Sampling Quantity"
                        name="sample_quantity"
                        rules={[
                          {
                            required: false,
                            message: 'Enter Sampling Quantity'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <Input placeholder="Enter Sampling Quantity" disabled />
                      </FormItem>
                    </Col>
                    <Col xs={24} xl={12} span={12} md={24} sm={24}>
                      <FormItem
                        label="Test Perfomed"
                        name="test_performed"
                        rules={[
                          {
                            required: false,
                            message: 'Enter Sampling Quantity'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <Select
                          placeholder="Select test perfomed"
                          disabled={!isEdit || qcSectionLocked}
                        >
                          {TEST_TO_BE_PERFORMED_OPTIONS.map((opt) => (
                            <option value={opt} key={opt}>
                              {opt}
                            </option>
                          ))}
                        </Select>
                      </FormItem>
                    </Col>
                    <Col xs={24} xl={12} span={12} md={24} sm={24}>
                      <FormItem
                        label="Analytical Status of Material"
                        name="analytical_status"
                        rules={[
                          {
                            required: false,
                            message: 'Enter Analytical Status of Material'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <Select
                          placeholder="Select status"
                          disabled={!isEdit || qcSectionLocked}
                        >
                          <option value="Approved">Approved</option>
                          <option value="Rejected">Rejected</option>
                          <option value="Discontinued">Discontinued</option>
                          <option value="Others">Others</option>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col xs={24} xl={12} span={12} md={24} sm={24}>
                      <FormItem
                        label="Remarks"
                        name="remarks"
                        rules={[
                          {
                            required: false,
                            message: 'Enter remarks'
                          }
                        ]}
                        className={styles.customLable}
                      >
                        <Input
                          placeholder="Enter remarks"
                          disabled={!isEdit || qcSectionLocked}
                        />
                      </FormItem>
                    </Col>
                  </Row>
                </Card>
              ) : (
                ''
              )
            }
            <br />
          </>
        </Card>
        <br />
        <FormItem className="text-center">
          <Space>
            {samplings?.test_request_form?.id ? (
              <>
                <CustomButton
                  type="primary"
                  ghost
                  loading={loading}
                  onClick={() => history.back()}
                >
                  Cancel
                </CustomButton>
                {/* Same double-submit guard Create already had. This submit
                    renders a PDF and uploads it, which takes ~18s, and the button
                    stayed live and clickable for all of it — so a second click
                    fired a concurrent request against the same batch. */}
                {truckShow ? (
                  <Image
                    src={truck}
                    preview={false}
                    style={{ width: '100px !important', height: '100px' }}
                  />
                ) : (
                  <CustomButton
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                  >
                    Update
                  </CustomButton>
                )}
                {/* Re-renders the form from the request as it stands now, so an AR
                    entered later at QC approval appears. Shown only once the
                    request exists - there is nothing to re-print before that. */}
                <CustomButton
                  type="primary"
                  ghost
                  loading={reprinting}
                  onClick={handleReprint}
                >
                  Re-print
                </CustomButton>
              </>
            ) : (
              <>
                <CustomButton
                  type="primary"
                  ghost
                  loading={loading}
                  onClick={() => history.back()}
                >
                  Cancel
                </CustomButton>
                {truckShow ? (
                  <Image
                    src={truck}
                    preview={false}
                    style={{ width: '100px !important', height: '100px' }}
                  />
                ) : (
                  <CustomButton
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                  >
                    Create
                  </CustomButton>
                )}
              </>
            )}
          </Space>
        </FormItem>
      </Form>
    </Layout>
  );
};
export default TestRequestForm;
